import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin, FiClock, FiFacebook, FiLinkedin, FiInstagram } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="text-xl font-bold text-orange-500 mb-4">
              Hubler & Tex Facility Services
            </div>
            <p className="text-gray-300 mb-4">
              Ihr zuverlässiger Partner für professionelles Facility Management. Wo andere aufhören, fangen wir an.
            </p>
            <div className="flex space-x-4">
              <SafeIcon icon={FiFacebook} className="w-5 h-5 text-gray-400 hover:text-orange-500 cursor-pointer transition-colors" />
              <SafeIcon icon={FiLinkedin} className="w-5 h-5 text-gray-400 hover:text-orange-500 cursor-pointer transition-colors" />
              <SafeIcon icon={FiInstagram} className="w-5 h-5 text-gray-400 hover:text-orange-500 cursor-pointer transition-colors" />
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Leistungen</h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li><Link to="/services" className="hover:text-orange-500 transition-colors">Reinigungsmanagement</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li><Link to="/team" className="hover:text-orange-500 transition-colors">Unser Team</Link></li>
              <li><Link to="/references" className="hover:text-orange-500 transition-colors">Referenzen</Link></li>
              <li><Link to="/blog" className="hover:text-orange-500 transition-colors">Blog & News</Link></li>
              <li><Link to="/portal" className="hover:text-orange-500 transition-colors">Kundenportal</Link></li>
              <li><Link to="/contact" className="hover:text-orange-500 transition-colors">Kontakt</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <div className="space-y-3 text-gray-300 text-sm">
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-orange-500 mt-0.5" />
                <div>
                  <div>Weissensteinstrasse 49</div>
                  <div>4923 Wynau</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-orange-500" />
                <span>+41 76 625 07 64</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-orange-500" />
                <span>info@hublertex.ch</span>
              </div>
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiClock} className="w-5 h-5 text-orange-500 mt-0.5" />
                <div>
                  <div>Mo-Fr: 07:00-18:00</div>
                  <div className="text-orange-500 font-semibold">24/7 Notfalldienst</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-xs sm:text-sm text-gray-400">
          <div>
            © 2024 Hubler & Tex Facility Services. Alle Rechte vorbehalten.
          </div>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="hover:text-orange-500 transition-colors">Datenschutz</Link>
            <Link to="/terms" className="hover:text-orange-500 transition-colors">AGB</Link>
            <Link to="/imprint" className="hover:text-orange-500 transition-colors">Impressum</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;